<script lang="ts" setup>
import Title1 from "@/components/Title/Title1.vue";
import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/vue";
import SwiperCore from "swiper";
import "swiper/css";
import { type CompetitionsList } from "@/utils/types";
import Card11 from "@/components/Card/Card11.vue";
const props = defineProps({
  data: {
    type: Array as PropType<any>,
    default: [],
  },
});
SwiperCore.use([Autoplay]);

const currentIndex: Ref<number> = ref(0);

const swiperSlideSelector = ref();
const onSwiper = (data: any) => {
  //存放 swiper
  swiperSlideSelector.value = data;
};

const swiperTo = (index: number) => {
  swiperSlideSelector.value.slideTo(index);
};

const handelSwiperChange = (data: any) => {
  currentIndex.value = data.realIndex;
};

const handleSlidePrev = () => {
  currentIndex.value = currentIndex.value - 1;
  if (currentIndex.value < 0) currentIndex.value = lists.value.length - 1;
  swiperTo(currentIndex.value);
};
const handleSlideNext = () => {
  currentIndex.value = currentIndex.value + 1;
  if (currentIndex.value >= lists.value.length) currentIndex.value = 0;
  swiperTo(currentIndex.value);
};
const lists = computed<CompetitionsList[]>(() => props.data.map((item: any) => {
  return {
    id: item.id,
    image: `${import.meta.env.VITE_STORAGE_URL}/${item.image}`,
    category: item.category?.name,
    titleEn: item.en_title,
    titleTw: item.title,
    deadline: useDateFormat(item.deadline, "MMM. DD, YYYY", { locales: "en-US" }).value,
    link: `/competition/${item.seo?.meta_slug || item.id}`,
  }
}))
</script>

<template>
  <section class="moreBox">
    <Title1 title="其他競賽資訊" class="moreBox__title" />
    <div class="moreBox__slide">
      <swiper :autoplay="{
        delay: 3000,
      }" :slides-per-view="3" :space-between="90" :speed="300" :loop="true" :breakpoints="{
  321: {
    slidesPerView: 2,
    spaceBetween: 12,
  },
  991: {
    slidesPerView: 3,
  },
}" class="swiper-list pc" @swiper="onSwiper" @slide-change="handelSwiperChange">
        <swiper-slide v-for="(item, index) in lists" :key="index">
          <div class="swiper-list__box">
            <Card11 :data="item" />
          </div>
        </swiper-slide>
      </swiper>
      <div class="moreBox__slide__arrow">
        <button class="buttonReset moreBox__slide__arrow__prev" @click="handleSlidePrev">
          <svg-icon name="icon-arrow-right2" />
        </button>
        <button class="buttonReset moreBox__slide__arrow__next" @click="handleSlideNext">
          <svg-icon name="icon-arrow-right2" />
        </button>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.moreBox {
  margin-bottom: 150px;

  &__title {
    margin-bottom: 50px;
  }

  &__slide {
    &__arrow {
      display: flex;
      justify-content: space-between;
      padding-top: 40px;

      &__prev {
        transform: scaleX(-1);
      }

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 30px;
        height: 12px;

        svg {
          display: block;
          width: 100%;
        }
      }
    }
  }
}
</style>
